type DefaultExportModule<TValue> = {
  default?: TValue | DefaultExportModule<TValue>;
};

/**
 * Resolves package default export interop for CommonJS-shaped browser modules.
 *
 * @param moduleValue The imported module or component value.
 * @returns The renderable default export when present, otherwise the original value.
 */
export const resolveDefaultExport = <TValue>(
  moduleValue: TValue | DefaultExportModule<TValue>,
): TValue => {
  let resolvedModuleValue: TValue | DefaultExportModule<TValue> | undefined =
    moduleValue;
  const visitedModules = new Set<unknown>();

  while (
    typeof resolvedModuleValue === "object" &&
    resolvedModuleValue !== null &&
    "default" in resolvedModuleValue &&
    resolvedModuleValue.default &&
    !visitedModules.has(resolvedModuleValue)
  ) {
    visitedModules.add(resolvedModuleValue);
    resolvedModuleValue = resolvedModuleValue.default;
  }

  return resolvedModuleValue as TValue;
};
